import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { DISTRIBUTION_JOBS_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

interface mutateProps {
  communityId: string;
  jobId: string
  data: FieldValues
}

const mutateUpdateJob = async ({ data, jobId, communityId }: mutateProps) => {
  return await axiosAuth.put(
    `${DISTRIBUTION_JOBS_API(communityId)}/${jobId}`,
    data
  );
};

const useUpdateJobMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateJob,
    ...queryParams,
  });

export default useUpdateJobMutation;
